module.exports = __webpack_public_path__ + "img/success-submit.34bf77a.webp";